import logo from './logo.svg';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import About from './components/About/About';
import HomePage from './components/HomePage/HomePage';
import ProjectPageManagement from './components/ProjectPage/ProjectPageManagement/ProjectPageManagement';
import BlogPageManagement from './components/BlogPage/BlogPageManagement/BlogPageManagement';
import NotFound from './NotFound/NotFound';
import ContactPage from './components/ContactPage/ContactPage';

function App() {
  return (
      <Router>
        <Switch>
          <Route path="/projectPage">
            <ProjectPageManagement />
          </Route>
          <Route path="/blogPage">
            <BlogPageManagement />
          </Route>
          <Route path="/contactPage">
            <ContactPage />
          </Route>
          <Route exact path="/">
            <HomePage />
          </Route>
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
      </Router>
  );
}

export default App;
